import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {TranslocoModule} from '@ngneat/transloco'
import {RouterModule} from '@angular/router'
import {ErrorComponent} from './error.component'
import {ErrorType} from './error.types'
import {PUBLIC_ROUTES} from '../../../shared/routing/public.routes'

@NgModule({
  declarations: [ErrorComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule.forChild([
      {
        path: '',
        pathMatch: 'full',
        redirectTo: PUBLIC_ROUTES.NOT_FOUND.routingPath,
      },
      {
        path: PUBLIC_ROUTES.NOT_FOUND.routingPath,
        component: ErrorComponent,
        data: {
          error: ErrorType.NOT_FOUND,
        },
      },
      {
        path: PUBLIC_ROUTES.UNKNOWN_ERR.routingPath,
        component: ErrorComponent,
        data: {
          error: ErrorType.UNKNOWN,
        },
      },
      {
        path: PUBLIC_ROUTES.AUTH_ERR.routingPath,
        component: ErrorComponent,
        data: {
          error: ErrorType.AUTH_ERROR,
        },
      },
    ]),
  ],
})
export class ErrorModule {}
